<template>
  <div class="fullHeight">
    <v-row style="background-color: #046174" class="ma-0 pa-0" v-if="$store.state.COMPANY_ID == 1">
      <v-col cols="6" style="color: white" class="ma-0 px-0 py-3">
        <img
          src="/img/maxam.png"
          height="40"
          class="pa-0 float-right"
        />
      </v-col>
      <v-col cols="6" class="px-4 py-3" style="color: white">
        <span>{{ $store.state["COMPANY_NAME_UZ_LATIN"] }}<br />Elektron hujjat aylanish tizimi</span>
      </v-col>
    </v-row>
    <v-row style="background-color: #4c6992" class="ma-0 pa-0" v-else-if="$store.state.COMPANY_ID == 2">
      <v-col cols="6" style="color: white" class="ma-0 px-0 py-3">
        <img
          src="/img/maxam.png"
          height="40"
          class="pa-0 float-right"
          style="background-color:#FFF;"
        />
      </v-col>
      <v-col cols="6" class="px-4 py-3" style="color: white">
        <span>{{ $store.state["COMPANY_NAME_UZ_LATIN"] }}<br />Elektron hujjat aylanish tizimi</span>
      </v-col>
    </v-row>
    <v-row style="background-color: #4c6992" class="ma-0 pa-0" v-else>
      <v-col cols="6" style="color: white" class="ma-0 px-0 py-3">
        <img
          src="/img/maxam.png"
          height="40"
          class="pa-0 float-right"
        />
      </v-col>
      <v-col cols="6" class="px-4 py-3" style="color: white">
        <span>{{ $store.state["COMPANY_NAME_UZ_LATIN"] }}<br />Elektron hujjat aylanish tizimi</span>
      </v-col>
    </v-row>
    <v-row v-if="false">
      <v-col></v-col>
      <v-col cols="10">
        <v-row v-if="!base64"><h1>Havfsizlik kodini kiriting.</h1></v-row>
        <v-row v-if="!base64">
          <v-col>
            <p><iframe :src="backend_url+'file-captcha/' + filename" style="width:68px;height:36px;border:0px;"></iframe></p>
            <img
              v-if="filename && false"
              :src="
                backend_url+'file-captcha/' + filename
              "
              height="50"
            />
            <v-btn outlined @click="getCaptcha()"
              ><v-icon>mdi-refresh</v-icon></v-btn
            >
            <div style="max-width: 150px; display: inline-block">
              <v-text-field
                v-model="captchaNumber"
                class="ml-2"
                outlined
                dense
                hide-details
                @keyup.enter="getFile"
              ></v-text-field>
            </div>
            <v-btn outlined class="ml-2" @click="getFile()">Yuborish</v-btn>
          </v-col>
        </v-row>
        <v-alert
          border="left"
          colored-border
          color="red accent-4"
          elevation="2"
          v-if="error == 1"
        >
          Bunday dokument mavjud emas.
        </v-alert>
        <v-alert
          border="left"
          colored-border
          color="red accent-4"
          elevation="2"
          v-if="error == 2"
        >
          Havfsizlik kodini tog'ri kiriting
        </v-alert>
      </v-col>
      <v-col></v-col>
    </v-row>
    <v-row v-if="document" class="mx-4">
      <v-col xl="5" offset-xl="2" lg="7"  offset-lg="1" md="7" sm="7" xs="12" cols="12">
        <pdf
          v-for="i in numPages"
          :key="i"
          :src="loadingTask"
          :page="i"
          style="margin-bottom: 20px; border: 9px double black"
        ></pdf>
      </v-col>
      <v-col xl="3" lg="3" md="5" sm="5" xs="12" cols="12">
        <v-card class="pa-1">
          <!-- From -->
          <v-list two-line>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>Yuboruvchi</v-list-item-title>
                <v-list-item-subtitle>
                  <b>{{ $store.state["COMPANY_NAME_UZ_LATIN"] }}</b>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>Hujjat raqami va sanasi</v-list-item-title>
                <v-list-item-subtitle>
                  <b>{{ document.document_number }}</b>
                  <b class="float-right">{{
                    getDateOnly(document.document_date)
                  }}</b>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-divider></v-divider>
          <b style="color: black; font-size: 18px; margin-left: 15px"
            >Tasdiqlovchi:
          </b>

          <v-list v-for="(signer, indx1) in rozilik" :key="indx1">
            <!--  -->
            <v-list-item v-if="signer">
              <v-list-item-content>
                <v-list-item-title
                  >Kim tomonidan va qachon imzolangan</v-list-item-title
                >
                <v-list-item-subtitle>
                  <v-list-item-subtitle>
                    <b style="font-size: 18px">
                      {{
                        getSignerDisplayName(signer)
                      }}</b
                    >
                    <span
                      class="float-right"
                      style="color: black; font-size: 18px"
                    >
                      <b>{{ signer.signed_at }}</b>
                    </span>
                  </v-list-item-subtitle>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <!--  -->
            <v-list-item
              v-if="
                signer &&
                hasSignerEimzo(signer)
              "
            >
              <v-list-item-content>
                <v-list-item-title
                  >ERI kim tamonidan berilgan</v-list-item-title
                >
                <v-list-item-subtitle>
                  <b>{{
                    getEimzoInfo(
                      getSignerUserKey(signer)
                    )[2][1]
                  }}</b>
                </v-list-item-subtitle>
                <v-list-item-subtitle>
                  <b>{{
                    getEimzoInfo(
                      getSignerUserKey(signer)
                    )[0][1]
                  }}</b>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <!--  -->
            <v-list-item
              v-if="
                signer &&
                hasSignerEimzo(signer)
              "
            >
              <v-list-item-content>
                <v-list-item-title>ERI seriya raqami</v-list-item-title>
                <v-list-item-subtitle>
                  <b>{{
                    getEimzoSerial(getSignerUserKey(signer))
                  }}</b>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <!--  -->
            <v-list-item
              v-if="
                signer &&
                hasSignerEimzo(signer)
              "
            >
              <v-list-item-content>
                <v-list-item-title>ERI amal qilish muddati</v-list-item-title>
                <v-list-item-subtitle>
                  <b>{{
                    getDate(
                      getEimzoCert(getSignerUserKey(signer))
                    )
                  }}</b>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
          </v-list>
          <b style="color: black; font-size: 18px; margin-left: 15px"
            >Rozilik beruvchilar:
          </b>
          <v-list v-for="(signer, indx) in signers" :key="indx">
            <v-divider v-if="indx != 0"></v-divider>
            <v-list-item v-if="signer">
              <v-list-item-content>
                <v-list-item-title
                  >Kim tomonidan va qachon imzolangan</v-list-item-title
                >
                <v-list-item-subtitle>
                  <v-list-item-subtitle>
                    <b>
                      {{
                        getSignerDisplayName(signer)
                      }}</b
                    >
                    <span class="float-right">
                      <b>{{ getDateTimestamp(signer.signed_date) }}</b>
                    </span>
                  </v-list-item-subtitle>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <!--  -->
            <v-list-item
              v-if="
                signer &&
                hasSignerEimzo(signer)
              "
            >
              <v-list-item-content>
                <v-list-item-title
                  >ERI kim tamonidan berilgan</v-list-item-title
                >
                <v-list-item-subtitle>
                  <b>{{
                    getEimzoInfo(
                      getSignerUserKey(signer)
                    )[2][1]
                  }}</b>
                </v-list-item-subtitle>
                <v-list-item-subtitle>
                  <b>{{
                    getEimzoInfo(
                      getSignerUserKey(signer)
                    )[0][1]
                  }}</b>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <!--  -->
            <v-list-item
              v-if="
                signer &&
                hasSignerEimzo(signer)
              "
            >
              <v-list-item-content>
                <v-list-item-title>ERI seriya raqami</v-list-item-title>
                <v-list-item-subtitle>
                  <b>{{
                    getEimzoSerial(getSignerUserKey(signer))
                  }}</b>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <!--  -->
            <v-list-item
              v-if="
                signer &&
                hasSignerEimzo(signer)
              "
            >
              <v-list-item-content>
                <v-list-item-title>ERI amal qilish muddati</v-list-item-title>
                <v-list-item-subtitle>
                  <b>{{
                    getDate(
                      getEimzoCert(getSignerUserKey(signer))
                    )
                  }}</b>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-list>
            <v-divider></v-divider>
            <v-list-item
              v-if="
                performer &&
                (performer.signer_employee ||
                  (performer.staff &&
                    performer.staff.employees &&
                    performer.staff.employees.length > 0))
              "
            >
              <v-list-item-content>
                <v-list-item-title>Mas'ul</v-list-item-title>
                <v-list-item-subtitle v-if="performer.signer_employee">
                  <b>{{
                    getSignerFallbackName(performer)
                  }}</b>
                </v-list-item-subtitle>
                <v-list-item-subtitle v-else>
                  <b>{{
                    getSignerFallbackName(performer)
                  }}</b>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-divider v-if="files.length"></v-divider>
            <v-list-item v-if="files.length">
              <v-list-item-content>
                <v-list-item-title> Biriktirilgan fayllar </v-list-item-title>
                <v-list-item-subtitle v-for="(file, k) in files" :key="k">
                  <a
                    :href="
                      backend_url + 'get-file-by-name/' + file.physical_name
                    "
                    target="_blank"
                    >{{ file.file_name }}</a
                  >
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="loading" width="300" hide-overlay>
      <v-card color="primary" dark>
        <v-card-text>
          {{ $t("loadingText") }}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Template from "../../../frontend/src/views/document/Template.vue";
import pdf from "vue-pdf";
const axios = require("axios").default;
const moment = require("moment");

export default {
  components: { Template, pdf },
  data() {
    return {
      backend_url: '',
      item: "",
      loadingTask: null,
      numPages: undefined,
      loading: false,
      captchaImage: "",
      captchaNumber: "",
      filename: "",
      base64: null,
      document: null,
      actionTypes: [],
      error: "",
      signers: [],
      rozilik: [],
      // signer: null,
      performer: null,
      files: [],
      screen: null,
    };
  },
  methods: {
    getSignerUserKey(signer) {
      return signer &&
        signer.signer_employee &&
        signer.signer_employee.user &&
        signer.signer_employee.user.eimzo_password
        ? signer.signer_employee.user.eimzo_password
        : "";
    },
    getSignerFallbackEmployee(signer) {
      if (signer && signer.signer_employee) {
        return signer.signer_employee;
      }
      if (
        signer &&
        signer.staff &&
        signer.staff.employees &&
        signer.staff.employees.length
      ) {
        return signer.staff.employees[0];
      }
      return null;
    },
    getSignerFallbackName(signer) {
      const employee = this.getSignerFallbackEmployee(signer);
      if (employee) {
        const firstname =
          employee.firstname_uz_latin || employee.firstname_uz_cyril || "";
        const middlename =
          employee.middlename_uz_latin || employee.middlename_uz_cyril || "";
        const lastname =
          employee.lastname_uz_latin || employee.lastname_uz_cyril || "";
        const firstInitial = firstname ? firstname.substr(0, 1) + ". " : "";
        const middleInitial = middlename ? middlename.substr(0, 1) + ". " : "";
        const fullName = (firstInitial + middleInitial + lastname).trim();
        if (fullName) {
          return fullName;
        }
      }
      return signer && signer.fio ? signer.fio : "...";
    },
    getSignerDisplayName(signer) {
      const eimzoName = this.getEimzoFio(this.getSignerUserKey(signer));
      return eimzoName !== "..." ? eimzoName : this.getSignerFallbackName(signer);
    },
    hasSignerEimzo(signer) {
      const key = this.getSignerUserKey(signer);
      return !!(signer && signer.sign_type && key && this.getEimzoInfo(key).length);
    },
    json_encode(v) {
      return JSON.parse(v);
    },
    getEimzoSerial(key) {
      if (this.document.eimzoinfo && key) {
        let obj = this.document.eimzoinfo.signers.find(
          (v) =>
            v.signerId.subjectSerialNumber.toUpperCase() == key.toUpperCase()
        );
        if (obj) {
          return obj.signerId.subjectSerialNumber;
        }
      }
      return "";
    },
    getEimzoInfo(key) {
      if (this.document.eimzoinfo && key) {
        let obj = this.document.eimzoinfo.signers.find(
          (v) =>
            v.signerId.subjectSerialNumber.toUpperCase() == key.toUpperCase()
        );
        if (obj) {
          return obj.signerId.issuer.split(",").map((v) => v.split("="));
        }
      }
      return [];
    },
    getEimzoCert(key) {
      if (this.document.eimzoinfo && key) {
        let obj = this.document.eimzoinfo.signers.find(
          (v) =>
            v.signerId.subjectSerialNumber.toUpperCase() == key.toUpperCase()
        );
        if (obj) {
          return obj.certificate[0].validTo;
        }
      }
      return [];
    },
    getEimzoFio(key) {
      if (this.document.eimzoinfo && key) {
        let obj = this.document.eimzoinfo.signers.find(
          (v) =>
          v.signerId.subjectSerialNumber.toUpperCase() == key.toUpperCase()
          );
          if (obj) {
            return obj.certificate[0].subjectName.substring(
                obj.certificate[0].subjectName.indexOf("CN=")+3,
                obj.certificate[0].subjectName.lastIndexOf(",Name=")
            );
          }
        }
      return '...';
    },
    getDateTimestamp(timestamp) {
      return moment
        .unix(timestamp)
        .locale("uz-latn")
        .format("DD-MMM. YYYY[y]. HH:mm");
    },
    getDate(date) {
      return moment(date).locale("uz-latn").format("DD-MMM. YYYY[y]. HH:mm");
    },
    getDateOnly(date) {
      return moment(date).locale("uz-latn").format("DD-MMM. YYYY[y]");
    },
    getCaptcha() { 
      location.reload();
    },
    getFile() {
      this.loading = true;
      axios
        .post(this.$store.state.backend_url + "get-file", {
          filename: this.filename,
          captchaNumber: this.captchaNumber,
        })
        .then((res) => {
          if (res.data == 0 || res.data == 1 || res.data == 2) {
            this.error = res.data;
            alert(this.error);
          } else {
            this.document = res.data.document;
            this.files = res.data.document_files;
            this.signers = this.document.document_signers.filter(
              (v) => v.action_type_id == 1
            );
            this.rozilik = this.document.document_signers
              .filter((v) => v.action_type_id == 2)
              .sort((a, b) => a.sequence > b.sequence);
            this.performer = this.document.document_signers.find(
              (v) => v.action_type_id == 6
            );
            this.actionTypes = res.data.actionTypes.filter(
              (v) => v.id != 8 && v.id != 9 && v.id != 10
            );

            this.base64 = res.data.document.pdf;
            this.loadingTask = pdf.createLoadingTask(
              "data:application/pdf;base64," + this.base64
            );
            this.loadingTask.promise.then((pdf) => {
              this.numPages = pdf.numPages;
            });

            this.error = "";
          }
        })
        .catch((error) => {
          console.log(error);
	  alert("Xatolik: " + error);
        });
      this.loading = false;
    },
  },
  mounted() {
    this.backend_url = this.$store.state.backend_url;
    this.filename = this.$route.params.name;
    this.screen = screen;
    this.getFile();
  },
};
</script>
<style>
b {
  color: #4c6992;
}
.v-list,
.v-list-item {
  background-color: white !important;
}
</style>
